<template>
  <div>
    <div class="admin__title">
      <div class="admin__survey">
        <h1 class="no-margin" v-if="activeSurvey.id">
          <router-link :to="{ name: 'admin-show-survey' }">{{ activeSurvey.title }}</router-link> <span class="note">Ref: <router-link :to="{ name: 'survey-new', params: { surveyRef: activeSurvey.reference } }">{{ activeSurvey.reference }}</router-link></span>
        </h1>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'admin-survey-header',

    computed: {
      ...mapGetters('admin', [
        'activeSurvey',
        'activePage',
      ]),
    },
  };
</script>
